import { Image, UIText2 } from '@cian/ui-kit';
import React from 'react';

import { H2 } from '../H2';
import { Section } from '../Section';
import { BenefitsCardList } from '../BenefitsCardList';
import { BenefitsCardListItem } from '../BenefitsCardListItem';

import * as styles from './styles.css';

export const OurBenefitsSection: React.FC = () => {
  return (
    <Section testId="ourBenefitsSection">
      <H2 className={styles['h2']}>Наши преимущества</H2>
      <BenefitsCardList>
        <BenefitsCardListItem
          title="Безопасно"
          description="Подписываем сделку электронной подписью, которую невозможно подделать"
          imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/safety_x1.png"
          imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/safety_x2.png"
        >
          <div className={styles['government-support-label']}>
            <div className={styles['government-support-label-image']}>
              <Image
                src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/government_support.svg"
                width={36}
                height={36}
                loading="lazy"
              />
            </div>
            <UIText2>
              Подпись выпустит удостоверяющий центр, аккредитованный Министерством цифрового развития, связи и массовых
              коммуникаций РФ.
            </UIText2>
          </div>
        </BenefitsCardListItem>
        <BenefitsCardListItem
          title="Быстро"
          description="Отправляем документы на регистрацию напрямую в Росреестр, минуя МФЦ"
          imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/sand_clock_x1.png"
          imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/sand_clock_x2.png"
        />
        <BenefitsCardListItem
          title="Комфортно и без стресса"
          description="Каждый этап сопровождает опытный персональный помощник"
          imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/ok_sign_x1.png"
          imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/ok_sign_x2.png"
        />
      </BenefitsCardList>
    </Section>
  );
};
